// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3AytK","productName":"Table_productName__3QUwk"};